import React from "react";
import { ScrollView, Text, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "../skeleton-components/Skeletons";

const DescriptionScrollView = ({
  styles,
  heading,
  details,
  showLoader = false,
  maxHeightPhone = 100,
  maxHeightScreen = 350,
}) => {
  const deviceSize = useDeviceSize();
  return (
    <View style={styles.detailTextStyle}>
      {showLoader ? (
        <Skeletons
          height={10}
          width={"100px"}
          style={{
            marginLeft: 10,
            borderRadius: 10,
          }}
        />
      ) : (
        heading && (
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_12,
              {
                paddingBottom: 12,
                paddingHorizontal: 18,
                paddingTop: 0,
                color: AppColors.white,
              },
            ]}
          >
            {heading}
          </Text>
        )
      )}

      <ScrollView
        style={{
          maxHeight:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? maxHeightPhone
              : maxHeightScreen,
        }}
      >
        {showLoader ? (
          <Skeletons
            height={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "65px"
                : "290px"
            }
            width={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "200px"
                : "350px"
            }
            style={{
              marginLeft: 10,
              borderRadius: 10,
            }}
          />
        ) : (
          details && (
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_12,
                { padding: 12, color: AppColors.white },
              ]}
            >
              {details != null && details.description
                ? details.description
                : ""}
            </Text>
          )
        )}
      </ScrollView>
    </View>
  );
};

export default withErrorBoundary(DescriptionScrollView);
